const host = window.location.protocol + '//' +
    window.location.hostname + (window.location.port ? ':' + window.location.port : '');

export const DOC_LIST_BY_CMR_ID_API = (cmrId: string) => {
    return host + `/docList/${cmrId}`;
};

export const PDF_DOC_API = (pdfName: string) => {
    return host + `/assets/mock-data/${pdfName}`;
};



// WEBPACK FOOTER //
// ./src/app/services/api.constants.ts